/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CustomInputs */

const en_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const es_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

const fr_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisé`)
};

const de_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefiniert`)
};

const ja_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム`)
};

const zh_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义`)
};

const ar_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخصص`)
};

const id_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kustom`)
};

const it_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizzato`)
};

const ru_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательский`)
};

const pt_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

const ko_val_custom = /** @type {(inputs: Val_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커스텀`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Val_CustomInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_custom = /** @type {((inputs?: Val_CustomInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CustomInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_custom(inputs)
	if (locale === "es") return es_val_custom(inputs)
	if (locale === "fr") return fr_val_custom(inputs)
	if (locale === "de") return de_val_custom(inputs)
	if (locale === "ja") return ja_val_custom(inputs)
	if (locale === "zh") return zh_val_custom(inputs)
	if (locale === "ar") return ar_val_custom(inputs)
	if (locale === "id") return id_val_custom(inputs)
	if (locale === "it") return it_val_custom(inputs)
	if (locale === "ru") return ru_val_custom(inputs)
	if (locale === "pt") return pt_val_custom(inputs)
	return ko_val_custom(inputs)
});